import { useTrans } from "@/translations";

import { FC } from "react";

export const ErrorNotice: FC<{ errorMessage?: string }> = ({
  errorMessage = "errors:failToFetch",
}) => {
  const { t } = useTrans();
  return (
    <h3 className="font-base font-dm-sans text-carrot-red flex h-full min-h-[420px] items-center justify-center font-bold whitespace-pre-wrap">
      {t(errorMessage)}
    </h3>
  );
};

export default ErrorNotice;
